import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'abbreviatedMonthDate',
})
export class AbbreviatedMonthDatePipe
  extends DatePipe
  implements PipeTransform
{
  override transform(value: any, args?: any): any {
    let parsedDate: Date;

    if (typeof value === 'string') {
      parsedDate = new Date(value);
    } else {
      parsedDate = value;
    }

    if (isNaN(parsedDate.getTime())) {
      return 'Invalid Date';
    }

    return super.transform(parsedDate, 'MMM dd, yyyy');
  }
}
